// @ts-nocheck
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';

@Injectable()
export class AuthService
{
    private _authenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string)
    {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string
    {
        return localStorage.getItem('accessToken') && (localStorage.getItem('accessToken') !== 'undefined') ? localStorage.getItem('accessToken') : '';
    }

    /**
     * Setter & getter for access token
     */
    set refreshToken(token: string)
    {
        localStorage.setItem('refreshToken', token);
    }

    get refreshToken(): string
    {
        return localStorage.getItem('refreshToken') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any>
    {
        return this._httpClient.post('api/auth/password', {email: email});
    }

    public changePassword(data: { email: any; token: any; password: any; passwordConfirmation: any}): Observable<any> {
        return this._httpClient.put('/api/auth/password', data);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any>
    {
        return this._httpClient.post('api/auth/reset-password', password);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string }): Observable<any>
    {
        // Throw error, if the user is already logged in
        if ( this._authenticated )
        {
            return throwError('User is already logged in.');
        }

        return this._httpClient.post('/api/auth/login-web', credentials).pipe(
            switchMap((response: any) => {

                // Store the access token in the local storage
                this.accessToken = response.accessToken;

                // Store the refresh token in the local storage
                this.refreshToken = response.refreshToken;

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                // this._userService.user = response.user;

                // Return a new observable with the response
                return of(response);
            })
        );
    }

    /**
     * Refresh token
     */
    tryToRefreshToken(): Observable<any>
    {
        return this._httpClient.post('/api/auth/refresh-token', {
            refreshToken: this.refreshToken
        }).pipe(
            catchError(() => {
                    // Return false @todo: Delete local storage and setup _authenticated
                   this._authenticated = false;
                   localStorage.removeItem('accessToken');
                   localStorage.removeItem('refreshToken');
                   return of(false);
                }
            ),
            switchMap((response: any) => {
                if (response === false) {
                    this._authenticated = false;
                    localStorage.removeItem('accessToken');
                    localStorage.removeItem('refreshToken');
                    return of(false);
                } else {
                    this.accessToken = response.accessToken;
                    this.refreshToken = response.refreshToken;
                    return of(true);
                }
            })
        );
    }


    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any>
    {

        // Renew token
        return this._httpClient.get('/api/auth/logged-user').pipe(
            catchError(() =>

                // Return false
                of(false)
            ),
            switchMap((response: any) => {

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response;

                // Return true
                return of(true);
            })
        );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any> {

        this.logout().subscribe();

        // Remove the access token from the local storage
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');

        // Set the authenticated flag to false
        this._authenticated = false;

        this.clearLoggedUserCache();

        // Return the observable
        return of(true);
    }


    /**
     * Sign up a partner-user object
     *
     * @param user
     */
    signUp(user): Observable<any>
    {
        return this._httpClient.post('api/partner/register', user).pipe(
            switchMap((response: any) => of(response))
        );
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean>
    {
        // Check if the user is logged in
        if ( this._authenticated )
        {
            return of(true);
        }

        // Check the access token availability
        if ( !this.accessToken )
        {
            return of(false);
        }

        // Check the access token expire date
        if ( AuthUtils.isTokenExpired(this.accessToken) )
        {
            console.log('expired - try to refresh');
            return this.tryToRefreshToken();
        }

        // If the access token exists and it didn't expire, sign in using it
        return of(true);
    }

    logout(): Observable<any>{
        return this._httpClient.delete('api/auth/logout');
    }

    public clearLoggedUserCache() {
        this.userSaved = null;
        this.observableUser = null;
    }
}
